import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

export type LiteralKind = 'number' | 'string' | 'string[]' | 'null';

export type LiteralControlPayload = {
  kind: 'literalControl';
  literalKind: LiteralKind;
  value: unknown;
  onChange: (next: unknown) => void;
};

@Component({
  selector: 'app-literal-control',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './literal-control.component.html',
  styleUrl: './literal-control.component.scss',
})
export class LiteralControlComponent {
  @Input({ required: true }) data!: LiteralControlPayload;

  displayValue(): string {
    const v = this.data.value;
    if (this.data.literalKind === 'string[]') {
      return Array.isArray(v) ? v.join(',') : '';
    }
    if (v === null || v === undefined) return '';
    return String(v);
  }

  changeText(next: string): void {
    if (this.data.literalKind === 'number') {
      const n = Number(next);
      this.data.onChange(Number.isFinite(n) ? n : 0);
      return;
    }
    if (this.data.literalKind === 'string') {
      this.data.onChange(next);
      return;
    }
    if (this.data.literalKind === 'string[]') {
      // カンマ区切り（空要素は除外）
      const arr = next
        .split(',')
        .map((x) => x.trim())
        .filter((x) => x.length > 0);
      this.data.onChange(arr);
      return;
    }
  }
}

